/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_STORES_WITH_ID = gql`
query Query($size: Int, $offset: Int, $filter: StoreFilter, $storeId: String) {
    findStore(size: $size, offset: $offset, filter: $filter) {
      data {
        id
        name
        logo
        desc
        supported_currencies
      }
      currentPage
      pageSize
      totalCount
      totalPages
    }

    getCategoriesByStore(storeId: $storeId) {
      categories
    }
    getSupportedNetworks(storeId: $storeId)
  }
`;
